import * as React from "react";

const Star = ({
  className,
  color,
  onClick,
}: {
  className?: string;
  color?: string;
  onClick?: (event: React.MouseEvent) => void;
}) => {
  return (
    <div
      className={`${className} flex items-center justify-center relative`}
      onClick={onClick}
    >
      <svg
        width="32"
        height="31"
        viewBox="0 0 32 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7647 8.10434C10.1103 9.40891 10.0587 9.49575 8.52084 9.66497C6.35039 9.90363 4.29282 10.1626 2.02299 10.5104C-0.0764136 10.8321 -0.751377 12.8423 1.00648 14.2906C1.89015 15.0187 2.76979 15.7509 3.6518 16.4801C4.82515 17.4501 6.18708 17.7911 7.67972 17.5723C10.3631 17.1791 12.9243 16.7841 15.564 16.383C15.9166 16.3295 16.7984 16.1152 16.9315 16.5485C17.0273 16.8604 16.7087 17.0468 15.9848 17.4181C13.8479 18.5145 11.0831 19.7255 9.11419 20.9817C8.58376 21.32 8.11118 21.6864 7.77003 22.0847C6.2923 23.8099 6.34542 25.6308 6.03316 27.7665C5.59847 30.7392 6.94358 31.5278 9.50736 30.2083C11.1152 29.3807 12.7171 28.5367 14.3281 27.7153C15.4966 27.1195 15.7785 26.8148 17.0527 27.5154C18.9254 28.5449 21.0038 29.8366 22.9085 30.7329C24.496 31.4798 26.1272 30.6063 26.0589 28.7863C25.9754 26.564 25.4835 24.3735 25.2448 22.1837C25.1027 20.8799 24.7036 20.327 25.7176 19.3591C27.5968 17.5654 29.424 15.7195 31.2509 13.8721C32.5158 12.593 32.2846 10.71 29.74 10.4063C27.5652 10.1468 25.3805 9.91425 23.2084 9.62674C21.807 9.44124 21.5026 9.18557 20.8912 7.9487C19.7776 5.69596 18.5583 3.11077 17.4315 0.916617C16.8145 -0.284823 15.1044 -0.323454 14.4109 0.908876C13.2506 2.97053 11.8826 5.87571 10.7647 8.10434Z"
          fill={color ? color : "#FFD900"}
        />
      </svg>
    </div>
  );
};

export default Star;
